/**
 * Shell principal — Sidebar + Topbar + contenu (réf. SkillMap V0).
 */
import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function AppShell() {
  return (
    <div className="sm-shell">
      <Sidebar />
      <div className="sm-shell-content">
        <Topbar />
        <main className="sm-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
